module.exports = __webpack_public_path__ + "images/logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 775
// module chunks = 0